import { render, staticRenderFns } from "./btn-excluir.vue?vue&type=template&id=390cb6c5&scoped=true"
import script from "./btn-excluir.vue?vue&type=script&lang=js"
export * from "./btn-excluir.vue?vue&type=script&lang=js"
import style0 from "./btn-excluir.vue?vue&type=style&index=0&id=390cb6c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390cb6c5",
  null
  
)

export default component.exports